var map = {
	"./1.png": 689,
	"./2.png": 690,
	"./3.png": 691,
	"./4.png": 692,
	"./5.png": 693,
	"./5.svg": 694,
	"./6.png": 695,
	"./7.png": 696,
	"./CloudGuard-Service.svg": 697,
	"./DNS.svg": 698,
	"./GoDown.png": 699,
	"./GoDown.svg": 700,
	"./GoTop.png": 701,
	"./GoTop.svg": 702,
	"./Group 420.png": 703,
	"./Group 420.svg": 704,
	"./Group 78.png": 705,
	"./Group 78.svg": 706,
	"./Group.png": 707,
	"./Insta.png": 708,
	"./ManagedService-Service.svg": 709,
	"./VPC-Service.svg": 710,
	"./VPS-Service.svg": 711,
	"./anjoman_s.png": 712,
	"./anjoman_s.svg": 713,
	"./bar.svg": 714,
	"./cloud-dns.svg": 715,
	"./contact.png": 716,
	"./contact.svg": 688,
	"./daneshbonyan.png": 717,
	"./daneshbonyan.svg": 718,
	"./ddos.svg": 719,
	"./discount.png": 720,
	"./discount.svg": 721,
	"./enamad-logo.png": 722,
	"./enamad-logo.svg": 723,
	"./facebook.png": 724,
	"./facebook.svg": 725,
	"./github.png": 726,
	"./github.svg": 727,
	"./insta.svg": 728,
	"./instagram.png": 729,
	"./instagram.svg": 730,
	"./linked.svg": 731,
	"./linkedin.png": 732,
	"./linkedin.svg": 733,
	"./new/xaas-instagram.png": 734,
	"./new/xaas-linkedin.png": 735,
	"./new/xaas-telegram.png": 736,
	"./new/xaas-twitter.png": 737,
	"./new/xaas-youtube.png": 738,
	"./nezam-senfi.png": 739,
	"./nezam-senfi.svg": 740,
	"./quote.png": 679,
	"./showMore.svg": 674,
	"./tweet.svg": 741,
	"./tweter.png": 742,
	"./twitter.png": 743,
	"./twitter.svg": 744,
	"./vps_icon2.png": 745,
	"./xaas-fab.png": 746,
	"./xaas-fab.svg": 747,
	"./xaas-occc.png": 748,
	"./xaas-occc.svg": 749,
	"./xaas-riasat-jomhoori.png": 750,
	"./xaas-riasat-jomhoori.svg": 751
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 681;